import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import {
  getTopTopicsByIsin,
  TopTopicByIsin,
} from "../methods/getTopTopicsByIsin";

export const useTopTopicsByIsin = (
  isins: string[],
  limit: number,
  enabled = true
) => {
  const dedupedIsins = useMemo(() => Array.from(new Set(isins)), [isins]);

  return useQuery<TopTopicByIsin[], Error>({
    queryKey: ["boersennews", "topTopicsByIsin", dedupedIsins, limit],
    queryFn: () => getTopTopicsByIsin(dedupedIsins, limit),
    enabled: enabled && dedupedIsins.length > 0,
  });
};
